import axios from 'axios';

export function sendTrainings(data) {
    return axios({
        method: 'post',
        url: '/api/v1/typedEmails',
        data,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteTraining({ mailId }) {
    return axios({
        method: 'delete',
        url: `/api/v1/typedEmails/${mailId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/trainings.js